export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";